var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"py-4",attrs:{"fluid":""}},[_c('h1',[_vm._v("404")]),_c('h2',[_vm._v("NOT FOUND!")])])}
var staticRenderFns = []

export { render, staticRenderFns }